import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [RouterModule],
  template: `
    <footer class="legal-footer">
      <div class="legal-footer__inner">
        <span>© United Team Building</span>
        <nav>
          <a routerLink="/terms-and-conditions">Terms and Conditions</a>
          <span class="sep">|</span>
          <a routerLink="/privacy-policy">Privacy Policy</a>
        </nav>
      </div>
    </footer>
  `,
  styles: [`
    .legal-footer { border-top: 1px solid var(--color-border); background: color-mix(in srgb, var(--color-surface-1) 94%, transparent); }
    .legal-footer__inner { max-width: 1280px; margin: 0 auto; padding: .75rem 1.4rem; display: flex; align-items: center; justify-content: space-between; gap: .8rem; color: var(--color-muted); font-size: .84rem; }
    nav { display: inline-flex; align-items: center; gap: .45rem; }
    a { color: var(--color-accent-soft); text-decoration: none; }
    a:hover { text-decoration: underline; }
    .sep { opacity: .6; }
  `]
})
export class LegalFooterComponent {}
